import { SVGProps } from 'react';

const Repeat2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 9 5 6 2 9m3-3v10a2 2 0 0 0 2 2h6m3-3 3 3 3-3m-3 3V8a2 2 0 0 0-2-2h-6"
    />
  </svg>
);
export default Repeat2;
